import { ColorType } from "../../Enums/ColorType"
import { DbImageData } from "../ImageData/DbImageData";
import { IConnectedSensor } from "./IConnectedSensor"

export class DbConnectedSensorNumber implements IConnectedSensor{
  id!: string;
  sensorId!: string
  sensorName!: string
  moduleName!: string

  showNotification: boolean = false;
  switchInputValue: boolean = false;
  visible: boolean = false;
  imageData!: DbImageData;
  
  reactionTimeForHigherThen!: number;
  reactionTimeForLowerThen!: number;
  thresholdForHigherThen!: number;
  thresholdForLowerThen!: number;
  messageByHigherThen!: string;
  messageByLowerThen!: string;

  colorForValueHigherThen!: ColorType;
  colorForValueLowerThen!: ColorType;

  public constructor(init?:Partial<DbConnectedSensorNumber>) {
    Object.assign(this, init);
  }
}


